import styled from 'styled-components';
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  .tag {
    margin-bottom: 2rem;
  }
`;
export const BackButton = styled.button `
  position: absolute;
  width: 4rem;
  height: 4rem;
  background: none;
  padding: 0;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  top: 0;
`;
export const Back = styled.svg `
  color: white;
  width: 1.8rem;
  height: 1.8rem;
  
  use {
    fill: white;
  }
`;
export const Icon = styled.svg `
  width: 3.4rem;
  height: 3.4rem;
  margin-bottom: 1rem;
  
  use {
    //fill: var(--secondary);
    fill: white;
  }
`;
export const Heading = styled.span `
  font: var(--heading-four-font);
  margin-bottom: 0;
  text-align: center;
`;
export const Copy = styled.span `
  font: var(--paragraph-font);
  margin: 0.5rem 0 0;
  text-align: center;
`;
export default {
    Wrapper,
};
